module.exports = __webpack_public_path__ + "media/images/svg/team-e66b2f221ae3967552f7d6ed6945b199.svg";